/* sm-flokkar-safn.js - "Sjá meira" í sm-flokkar-safn (sama hegðun og sm-oryggisskilti-safn). */
(function () {
  document.querySelectorAll("[data-sf-meira]").forEach(function (b) {
    b.addEventListener("click", function () {
      var g = document.getElementById(b.getAttribute("aria-controls"));
      if (!g) return;
      var opna = g.classList.contains("sf-cards--lokad");
      g.classList.toggle("sf-cards--lokad", !opna);
      b.setAttribute("aria-expanded", String(opna));
      var t = b.querySelector("[data-sf-meira-texti]"); if (t) t.textContent = opna ? (b.getAttribute("data-minna") || "Sjá minna") : (b.getAttribute("data-meira") || "Sjá meira");
      var f = b.querySelector(".sf-meira-fj"); if (f) f.hidden = opna;
      if (opna) {
        var fyrsta = g.querySelector(".sf-card--auka .sf-card-link");
        if (fyrsta) fyrsta.focus({ preventScroll: true });
      } else {
        var sek = g.closest(".sf-flokkur");
        if (sek && sek.getBoundingClientRect().top < 0) sek.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
})();

/* Leit, síur og röðun (leit 14.10.2026, síur og röðun 18.10.2026): allt á kortunum sem eru á síðunni, ekkert netkall.
   Leit: orðin borin saman án broddstafa ("slokkvi" finnur "Slökkvitæki"); spjöld sem sectionið teiknar ekki (adeins_hlekkur) liggja í
   <template data-sf-leit-forn> og eru sett inn (falin) við fyrstu notkun.
   Síur (data-sf-sia: efni, fyrir) og röðun (data-sf-rod) setja síðuna í flatan ham: kortin eru færð (ekki afrituð) í eina rist
   [data-sf-flatt] undir stikunni, hver vara einu sinni, og fara aftur á sinn stað (athugasemdarhnútur geymir staðinn) þegar allt er hreinsað.
   Ástandið fer í slóðina (?q=, ?efni=, ?fyrir=, ?rod=) svo hægt sé að deila. */
(function () {
  var rot = document.querySelector("[data-sf-leit-rot]");
  if (!rot) return;
  var sf = rot.closest(".sf") || document.body;
  var inn = rot.querySelector("[data-sf-leit-inntak]"), hr = rot.querySelector("[data-sf-leit-hreinsa]");
  var tel = rot.querySelector("[data-sf-leit-teljari]"), tomt = rot.querySelector("[data-sf-leit-tomt]");
  var rodSel = rot.querySelector("[data-sf-rod]"), hreinsaSiur = rot.querySelector("[data-sf-siur-hreinsa]");
  var flisar = Array.prototype.slice.call(rot.querySelectorAll("[data-sf-sia]"));
  var flatt = sf.querySelector("[data-sf-flatt]"), flattSp = flatt ? flatt.querySelector("[data-sf-flatt-spjold]") : null;
  var mal = (document.documentElement.lang || "is").slice(0, 2);

  function fold(s) {
    s = String(s || "").toLowerCase().replace(/ð/g, "d").replace(/þ/g, "th").replace(/æ/g, "ae");
    try { s = s.normalize("NFD").replace(/[̀-ͯ]/g, ""); } catch (e) {}
    return s.replace(/[^a-z0-9]+/g, " ").trim();
  }
  function listi(v, fors) {
    return String(v || "").split(";").map(function (x) { return x.replace(fors, "").trim(); }).filter(Boolean);
  }
  function lykill(k) {
    var a = k.querySelector("[data-sm-kort-link]"), nafn = k.querySelector(".sf-card-name"), tog = k.querySelectorAll(".sf-tag");
    var slod = a ? (a.getAttribute("href") || "").split("?")[0] : "";
    var t = [k.getAttribute("data-sf-leit") || "", nafn ? nafn.textContent : "", slod.split("/").pop().replace(/-/g, " ")];
    for (var i = 0; i < tog.length; i++) t.push(tog[i].textContent);
    return { slod: slod || ("#" + Math.random()), key: " " + fold(t.join(" ")) + " " };
  }

  var faerslur = [], skuggi = [], efniSett = false, erFlatt = false;
  function skra(k, forn) {
    var l = lykill(k);
    faerslur.push({ el: k, key: l.key, slod: l.slod, forn: forn, idx: faerslur.length,
      efni: listi(k.getAttribute("data-efni"), "efni:"), fyrir: listi(k.getAttribute("data-hopar"), "hopur:"),
      verd: parseInt(k.getAttribute("data-verd"), 10) || 0, handle: l.slod.split("/").pop(),
      heiti: k.getAttribute("data-heiti") || (k.querySelector(".sf-card-name") || {}).textContent || "", stadur: null });
  }
  sf.querySelectorAll(".sf-card").forEach(function (k) { if (!flatt || !flatt.contains(k)) skra(k, false); });
  sf.querySelectorAll("template[data-sf-leit-forn]").forEach(function (t) {
    var cont = t.parentNode.querySelector(".sf-cards");
    if (!cont) return;
    var spjold = t.content.querySelectorAll(".sf-card");
    for (var i = 0; i < spjold.length; i++) skra(spjold[i], true);
    skuggi.push({ t: t, cont: cont });
  });
  function setja() {
    if (efniSett) return; efniSett = true;
    skuggi.forEach(function (s) {
      var kort = s.t.content.querySelectorAll(".sf-card");
      for (var i = 0; i < kort.length; i++) { kort[i].hidden = true; s.cont.appendChild(kort[i]); }
    });
  }
  var einstok = {}; faerslur.forEach(function (f) { einstok[f.slod] = 1; });
  var alls = Object.keys(einstok).length;

  /* Vinsælast: listar úr söfnum sem er raðað eftir sölu (data-sala, 50 efstu í hverju). Sala er ein röð yfir allar vörur, svo tvær vörur
     í sama lista eru bornar saman þar; annars ræður hlutfallsleg staða, og vara utan allra lista fer aftast. */
  var salaPos = [];
  try { salaPos = JSON.parse(rot.getAttribute("data-sala") || "[]").map(function (L) { var m = { n: L.length }; L.forEach(function (h, i) { m["h:" + h] = i; }); return m; }); } catch (e) {}
  function salaBera(a, b) {
    var ka = "h:" + a.handle, kb = "h:" + b.handle, ra = Infinity, rb = Infinity;
    for (var i = 0; i < salaPos.length; i++) {
      var m = salaPos[i];
      if (ka in m && kb in m) return m[ka] - m[kb];
      if (ka in m) ra = Math.min(ra, m[ka] / m.n);
      if (kb in m) rb = Math.min(rb, m[kb] / m.n);
    }
    return ra === rb ? 0 : (ra < rb ? -1 : 1);
  }
  var siur = { efni: "", fyrir: "" };
  function rod() { return rodSel ? rodSel.value : ""; }
  function flatHamur() { return !!(flattSp && (rod() || siur.efni || siur.fyrir)); }
  function passarSia(f, sleppa) {
    if (siur.efni && sleppa !== "efni" && f.efni.indexOf(siur.efni) < 0) return false;
    if (siur.fyrir && sleppa !== "fyrir" && f.fyrir.indexOf(siur.fyrir) < 0) return false;
    return true;
  }
  function passarLeit(f, ord) {
    for (var i = 0; i < ord.length; i++) if (f.key.indexOf(ord[i]) < 0) return false;
    return true;
  }
  function samanburdur(r) {
    var heitiS = function (a, b) { try { return a.heiti.localeCompare(b.heiti, mal === "is" ? "is" : "en", { sensitivity: "base" }); } catch (e) { return a.heiti < b.heiti ? -1 : a.heiti > b.heiti ? 1 : 0; } };
    return function (a, b) {
      var d = 0;
      if (r === "vinsaelast") d = salaBera(a, b);
      else if (r === "heiti") d = heitiS(a, b);
      else if (r === "verd") d = a.verd - b.verd;
      else if (r === "verd-nidur") d = b.verd - a.verd;
      return d || (a.idx - b.idx);
    };
  }
  function iFlatt() {
    setja();
    faerslur.forEach(function (f) {
      if (f.stadur || !f.el.parentNode) return;
      f.stadur = document.createComment("sf");
      f.el.parentNode.insertBefore(f.stadur, f.el);
    });
    faerslur.slice().sort(samanburdur(rod())).forEach(function (f) {
      flattSp.appendChild(f.el);
      /* P2-A06: í flötum ham eru flokkaheitin (h2) falin, svo kortaheitin verða h2 fyrir skjálesara (annars h1 beint í h3) */
      var nm = f.el.querySelector(".sf-card-name");
      if (nm && !nm.hasAttribute("aria-level")) { nm.setAttribute("aria-level", "2"); nm.setAttribute("data-sf-nivo", ""); }
    });
  }
  function urFlatt() {
    faerslur.forEach(function (f) {
      if (!f.stadur) return;
      f.stadur.parentNode.replaceChild(f.el, f.stadur);
      f.stadur = null;
      var nm = f.el.querySelector(".sf-card-name[data-sf-nivo]");
      if (nm) { nm.removeAttribute("aria-level"); nm.removeAttribute("data-sf-nivo"); }
    });
  }

  function beita() {
    var q = inn.value, o = fold(q), ord = o ? o.split(" ") : [], leit = ord.length > 0;
    var flat = flatHamur();
    if (leit) setja();
    if (flat) iFlatt(); else if (erFlatt) urFlatt();
    erFlatt = flat;
    sf.classList.toggle("sf--leitar", leit || flat);
    sf.classList.toggle("sf--flatt", flat);
    if (flatt) flatt.hidden = !flat;
    var sed = {}, fj = 0;
    faerslur.forEach(function (f) {
      var m = passarLeit(f, ord) && passarSia(f);
      if (flat) {
        var syna = m && !sed[f.slod];
        if (syna) { sed[f.slod] = 1; fj++; }
        f.el.hidden = !syna;
      } else {
        if (leit && m && !sed[f.slod]) { sed[f.slod] = 1; fj++; }
        f.el.hidden = f.forn ? !(leit && m) : (leit && !m);
      }
    });
    sf.querySelectorAll(".sf-flokkur").forEach(function (s) { s.hidden = flat || (leit && !s.querySelector(".sf-card:not([hidden])")); });
    /* fjöldi á hverri flís: það sem sæist ef hún væri valin, miðað við leitina og hina síuna */
    flisar.forEach(function (b) {
      var teg = b.getAttribute("data-sf-sia"), g = b.getAttribute("data-gildi"), s2 = {}, n = 0;
      faerslur.forEach(function (f) {
        if (s2[f.slod] || f[teg].indexOf(g) < 0 || !passarLeit(f, ord) || !passarSia(f, teg)) return;
        s2[f.slod] = 1; n++;
      });
      var virk = siur[teg] === g;
      b.setAttribute("aria-pressed", String(virk));
      b.disabled = n === 0 && !virk;
      var fjEl = b.querySelector("[data-sf-sia-fj]"); if (fjEl) fjEl.textContent = n;
      /* heiti með orðinu "vörur" (QA20 A11, 20.10): "Akrýl, 26 vörur" í stað "Akrýl 26" */
      var h0 = b.firstChild ? String(b.firstChild.textContent || "").trim() : "";
      if (h0) b.setAttribute("aria-label", h0 + ", " + n + " " + (rot.getAttribute("data-vorur") || "vörur"));
    });
    var virkt = leit || flat;
    hr.hidden = !inn.value;
    if (hreinsaSiur) hreinsaSiur.hidden = !(siur.efni || siur.fyrir);
    tomt.hidden = !(virkt && fj === 0);
    tel.textContent = virkt ? (fj + " " + (rot.getAttribute("data-af") || "af") + " " + alls + " " + (rot.getAttribute("data-af-vorur") || "vörum")) : (alls + " " + (rot.getAttribute("data-vorur") || "vörur"));
    try {
      var u = new URL(location.href);
      var setjaP = function (k, v) { if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); };
      setjaP("q", leit ? inn.value.trim() : ""); setjaP("efni", siur.efni); setjaP("fyrir", siur.fyrir); setjaP("rod", rod());
      history.replaceState(null, "", u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function hreinsaAllt(fokus) {
    inn.value = ""; siur.efni = ""; siur.fyrir = ""; if (rodSel) rodSel.value = "";
    beita(); if (fokus) inn.focus();
  }

  inn.addEventListener("input", beita);
  inn.addEventListener("keydown", function (e) { if (e.key === "Escape" && inn.value) { e.preventDefault(); inn.value = ""; beita(); } });
  hr.addEventListener("click", function () { inn.value = ""; beita(); inn.focus(); });
  if (rodSel) rodSel.addEventListener("change", beita);
  flisar.forEach(function (b) {
    b.addEventListener("click", function () {
      var teg = b.getAttribute("data-sf-sia"), g = b.getAttribute("data-gildi");
      siur[teg] = siur[teg] === g ? "" : g;
      beita();
    });
  });
  if (hreinsaSiur) hreinsaSiur.addEventListener("click", function () { siur.efni = ""; siur.fyrir = ""; beita(); });
  sf.querySelectorAll(".sf-picker a.sf-pick").forEach(function (a) {
    a.addEventListener("click", function () { if (inn.value || erFlatt) hreinsaAllt(false); });
  });

  /* upphafsástand úr slóðinni (eða úr reitnum ef notandi skrifaði áður en JS kom) */
  var p0 = {}; try { p0 = Object.fromEntries(new URLSearchParams(location.search)); } catch (e) {}
  if (p0.q) inn.value = p0.q;
  flisar.forEach(function (b) { var teg = b.getAttribute("data-sf-sia"); if (p0[teg] && p0[teg] === b.getAttribute("data-gildi")) siur[teg] = p0[teg]; });
  if (rodSel && p0.rod) { for (var i = 0; i < rodSel.options.length; i++) if (rodSel.options[i].value === p0.rod) rodSel.value = p0.rod; }
  beita();
})();
